import type { FilenameMatchRank } from '../types/filename-match-rank'

/**
 * How closely a filename matches the "Search by filename" term — lower is closer. Results and
 * suggestions show the closest matches first. See `matchBackgroundFilename`.
 */
export const FILENAME_MATCH_RANK = {
  /** The term appears as typed (case-insensitive). */
  Exact: 0,
  /** It appears once spaces, punctuation and the file extension are ignored. */
  Normalized: 1,
  /** Every word of the term starts a word of the name, in any order. */
  Words: 2,
  /** Every word of the term is within a few typos of part of the name. */
  Fuzzy: 3,
} as const satisfies Record<string, FilenameMatchRank>
